import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Alert, Badge } from "components/bootstrap";
import { ConfirmDialog, Spinner, Switch } from "components/common";
import useAIConfiguration from "ai/hooks/useAIConfiguration";
import useAIConfigurationMutations from "ai/hooks/useAIConfigurationMutations";
const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.md};
  `
);
const Description = styled.div`
  flex-grow: 1;
`;
const Title = styled.h3(
  ({ theme }) => css`
    margin: 0;
    font-weight: bold;
    font-size: ${theme.fonts.size.large};
  `
);
const HelpText = styled.p`
  margin: 0;
`;
const DisabledAlert = styled(Alert)(
  ({ theme }) => css`
    margin-top: ${theme.spacings.sm};
  `
);
const AIFeaturesToggle = () => {
  const {
    data: { isEnabled },
    isLoading
  } = useAIConfiguration();
  const { enable, disable } = useAIConfigurationMutations();
  const [showDisableConfirm, setShowDisableConfirm] = useState(false);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const onChange = () => isEnabled ? setShowDisableConfirm(true) : enable();
  const onConfirmDisable = () => disable().finally(() => setShowDisableConfirm(false));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(Switch, { "aria-label": "AI features", checked: isEnabled, onChange }), /* @__PURE__ */ React.createElement(Description, null, /* @__PURE__ */ React.createElement(Title, null, "AI features"), /* @__PURE__ */ React.createElement(HelpText, null, isEnabled ? "Enables all AI features for all users. Turn off to stop every AI feature at once." : "Turned off. Turn on to make AI features available again with the current settings.")), /* @__PURE__ */ React.createElement(Badge, { color: isEnabled ? "success" : "gray", variant: "light", dot: true }, isEnabled ? "On" : "Off")), !isEnabled && /* @__PURE__ */ React.createElement(DisabledAlert, { bsStyle: "warning" }, "No AI feature sends requests to any provider. Provider and feature settings are kept and can still be edited and tested."), showDisableConfirm && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      title: "Turn off AI features",
      btnConfirmText: "Turn off",
      onConfirm: onConfirmDisable,
      onCancel: () => setShowDisableConfirm(false)
    },
    "This stops all AI features for all users. Provider and feature settings are kept."
  ));
};
export default AIFeaturesToggle;
